import React from 'react';

interface IOwnProps {
    headline: string;
    modifierClass?: string;
}

type Props = IOwnProps;

class Aside extends React.Component<Props, {}> {
    public render() {
        return <aside className={`aside${this.props.modifierClass ? ` ${this.props.modifierClass}` : ''}`}>
            {this.props.headline ? <div className="aside__item">
                <h2 className="aside__headline">{this.props.headline}</h2>
            </div> : null}
            {this.props.children}
            {this.props.children ? null : 'Ingen dokumenter'}
        </aside>;
    }
}

export default Aside;